export const MALFORMED_EMAIL = 'MALFORMED_EMAIL';
export const PREVIOUSLY_BOUNCED = 'PREVIOUSLY_BOUNCED';
export const MISSING_PERMISSION = 'MISSING_PERMISSION';